import { QueryHookOptions, gql, useQuery } from '@apollo/client'
import { ReviewableBrandProductsQuery, ReviewableBrandProductsQueryVariables } from 'types/graphql'

export const reviewableBrandProducts = gql`
  query ReviewableBrandProducts($brandId: ID!, $order: BrandProductSortOrder, $onlyWithReviews: Boolean) {
    brand(id: $brandId) {
      id
      title
      reviewableProducts(order: $order, onlyWithReviews: $onlyWithReviews) {
        id
        name
        slug
        numberOfReviews
      }
    }
  }
`

export const useBrandReviewableProducts = (options: QueryHookOptions<ReviewableBrandProductsQuery, ReviewableBrandProductsQueryVariables>) => {
  return useQuery<ReviewableBrandProductsQuery, ReviewableBrandProductsQueryVariables>(reviewableBrandProducts, options)
}
